module.exports = __webpack_public_path__ + "img/U1F60A.b0f36ffe.png";